import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import { styled, alpha } from '@mui/material';

const NoResultsWrapper = styled('div')(({ theme }) => ({
  background: alpha(theme.palette.primary.main, 0.05),
  textAlign: 'left',
  padding: '1rem',
  borderRadius: '6px'
}));

const ContentWrapper = styled('div', { shouldForwardProp: prop => !['overflow'].includes(prop) })(({ overflow = 'visible' }) => ({
  overflow
}));

const CardNoResultsWrapper = ({ content, message, children, overflow }) => {
  const { t } = useTranslation();
  const isContentEmpty = useMemo(() => content && content.length === 0, [content]);

  if (!isContentEmpty) return <ContentWrapper overflow={overflow}>{children}</ContentWrapper>;
  return <NoResultsWrapper>{message ?? t('ResultsNotFound')}</NoResultsWrapper>;
};

CardNoResultsWrapper.propTypes = {
  content: PropTypes.array.isRequired,
  message: PropTypes.string,
  children: PropTypes.oneOfType([PropTypes.array.isRequired, PropTypes.object.isRequired]),
  overflow: PropTypes.string
};

export default CardNoResultsWrapper;
